export default {
      id: "child-education-usage",
      viewBox: "0 0 95 95",
      url: __webpack_public_path__ + "sprite.svg#child-education",
      toString: function () {
        return this.url;
      }
    }